import { render, staticRenderFns } from "./ResultTableComponent.vue?vue&type=template&id=cbc87c54&"
import script from "./ResultTableComponent.vue?vue&type=script&lang=js&"
export * from "./ResultTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports